import { IConnectedService } from '../../model';

import { getApi } from './api';

const URL = '/connectedService';

const get = async (): Promise<IConnectedService[]> => {
  const api = await getApi();
  return api.get<IConnectedService[]>(`${URL}/lookup-values`).then((response) => response.data || []);
};

const getByCustomer = async (customerId: number): Promise<IConnectedService[]> => {
  const api = await getApi();
  return api.get<IConnectedService[]>(`${URL}/by-customer?id=${customerId}`).then((response) => response.data || []);
};

export const connectedServicesService = {
  get,
  getByCustomer,
};
